import { optionActivityCalendarRoutes } from './routes';

export class SignalsCalendarEnvironment {
  public static getName = () => 'benzinga-calendar-option-activity';

  public static getEnvironment = (env: Record<string, string>) => ({
    route: optionActivityCalendarRoutes.optionActivity,
    token: env.token ?? '',
    url: new URL(env.url ?? 'https://api.benzinga.com/api/'),
  });
}
